var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotAllowed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 10.6666H20.5334C21.2801 10.6666 21.6535 10.6666 21.9387 10.5213C22.1896 10.3935 22.3936 10.1895 22.5214 9.93863C22.6667 9.65342 22.6667 9.28005 22.6667 8.53331V5.33331M9.33337 7.99998V3.99998M14.6667 17.3333C13.92 17.3333 10.3466 17.3333 10.0614 17.4786C9.8105 17.6065 9.60653 17.8104 9.4787 18.0613C9.33337 18.3465 9.33337 18.7199 9.33337 19.4666V28M20 17.3333C20.7468 17.3333 21.6535 17.3333 21.9387 17.4786C22.1896 17.6065 22.3936 17.8104 22.5214 18.0613C22.6667 18.3465 22.6667 18.5866 22.6667 19.3333M22.6667 28V23.7333M28 23.7333V12.434C28 11.7817 28 11.4556 27.9264 11.1487C27.861 10.8766 27.7533 10.6165 27.6071 10.3779C27.4422 10.1088 27.2116 9.87817 26.7504 9.41697L22.5831 5.24966C22.1218 4.78845 21.8912 4.55785 21.6221 4.39294C21.3835 4.24673 21.1234 4.13898 20.8513 4.07366C20.5444 3.99998 20.2183 3.99998 19.5661 3.99998H10.4C8.15983 3.99998 7.03973 3.99998 6.18408 4.43595C5.43143 4.81945 4.81951 5.43137 4.43601 6.18402M27.5641 25.8159C27.1806 26.5686 26.5686 27.1805 25.816 27.564C24.9604 28 23.8402 28 21.6 28H10.4C8.15983 28 7.03973 28 6.18408 27.564C5.43143 27.1805 4.81951 26.5686 4.43601 25.8159C4.00004 24.9603 4.00004 23.8402 4.00004 21.6V7.99998M27.5641 25.8159L4.43601 6.18402M27.5641 25.8159L30.6667 28.6666M4.43601 6.18402L1.33337 3.33331",
    stroke: "#444CE7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotAllowed);
export default __webpack_public_path__ + "static/media/NotAllowed.0d19b9dded523a26f511262a64457eaf.svg";
export { ForwardRef as ReactComponent };